import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterLayoutComponent } from '../footer-layout/footer-layout.component';
import {
    ADPComponentsModule as ComponentsModule } from 'digital-core';
import { BaseFooterLayoutModule } from '../../base-layouts/footer/footer.module';
import { GspComponentsModule } from '../../modules';
import { GspSharedModule } from '../../modules';

@NgModule({
    imports: [
        CommonModule,
        BaseFooterLayoutModule,
        GspSharedModule,
        ComponentsModule,
        GspComponentsModule
    ],
    declarations: [
        FooterLayoutComponent
    ],
    exports: [
        FooterLayoutComponent
    ],
   
})
export class FooterLayoutModule { }
